import Settings from "./settings"
const settingRoutes = [
    {
        path: "/core/settings",
        element: <Settings />,
    }
]
export default settingRoutes